import React, { useEffect, useState } from "react";
import { Col } from "antd";
import { connect, useSelector } from "react-redux";
import JobCard from "./JobCard";
import Pagination from "./Pagination";
import * as consultantReducer from "../Redux/Consultant/reducer.js";
import * as clientReducer from "../Redux/client/reducer";
import constants from "../Redux/constants";
import Feedback from "../Utilities/Feedback";
import { LoadingOutlined } from "@ant-design/icons";

const SearchJobs = (props) => {
  const { searchText, clientSearch, consultantSearch } = props;
  const [page, setPage] = useState(0);
  const [jobs, setJobs] = useState([]);
  const [loadingJobs, setLoadingJobs] = useState(true);

  const { userRole } = useSelector((state) => state.userStore);

  const getPage = (page) => {
    setPage(page - 1);
    setTimeout(() => {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }, 1500);
  };
  useEffect(() => {
    const getSearchJobs = async () => {
      if (userRole === constants.roles.client) {
        const response = await clientSearch(searchText, page);
        if (response.responseStatus === constants.status.success) {
          setJobs(response.searchedJobs);
          setLoadingJobs(false);
        } else {
          setLoadingJobs(false);
        }
      } else if (userRole === constants.roles.consultant) {
        const response = await consultantSearch(searchText, page);
        if (response.responseStatus === constants.status.success) {
          setJobs(response.searchedJobs);
          setLoadingJobs(false);
        } else {
          setLoadingJobs(false);
        }
      }
    };
    getSearchJobs();
  }, [page, searchText, clientSearch, consultantSearch, userRole]);
  const { searchJobsCount } = useSelector(
    (state) => state.consultantStore || state.clientStore
  );
  return (
    <Col>
      {loadingJobs ? (
        <Feedback icon={<LoadingOutlined />} title="Searching the job" />
      ) : (
        <Col>
          {jobs.length >= 1 ? (
            <Col>
              {jobs.map((eachJob) => (
                <JobCard
                  key={eachJob.jobId}
                  id={eachJob.jobId}
                  title={eachJob.title}
                  typeRequirement={eachJob.typeRequirement}
                  targetStartDate={eachJob.targetStartDate}
                  targetEndDate={eachJob.targetEndDate}
                  userId={eachJob.userId}
                  createdDate={eachJob.createdDate}
                  t24Release={eachJob.T24Release}
                ></JobCard>
              ))}
              <Pagination totalJobs={searchJobsCount} getPage={getPage} />
            </Col>
          ) : (
            <Col>
              <Feedback
                status="404"
                title={`No Jobs found with '${searchText}'`}
              />
            </Col>
          )}
        </Col>
      )}
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    consultantSearch: (searchText, page) =>
      dispatch(consultantReducer.searchJobs(searchText, page)),
    clientSearch: (searchText, page) =>
      dispatch(clientReducer.searchJobs(searchText, page)),
  };
};

export default connect(null, mapDispatchToProps)(SearchJobs);
